import { SuperAdminConstants } from '../../../_constants';

const initialState = { makeOrgPrimaryAdminLoading: true, data: '', error: false };

export function makeOrgPrimaryAdmin(state = initialState, action) {

    switch (action.type) {
        case SuperAdminConstants.REQUEST_MAKE_ORG_PRIMARY_ADMIN:
            return {
                makeOrgPrimaryAdminLoading: true,
                data: '',
                error: false
            };
        case SuperAdminConstants.RECEIVE_MAKE_ORG_PRIMARY_ADMIN:
            return {
                makeOrgPrimaryAdminLoading: false,
                data: action.makeOrgPrimaryAdmin,
                error: false
            };
        case SuperAdminConstants.MAKE_ORG_PRIMARY_ADMIN_ERROR:
            return {
                makeOrgPrimaryAdminLoading: false,
                data: '',
                error: true
            };
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/SuperAdmin/ManageOrgAdmins/makeOrgPrimaryAdmin.reducer.js